// Template: Affiliate join request notification
export const AffiliateRequest = `
<div>

  <p style="font-size: 0.95rem; color: #4a5568; line-height: 1.9; margin-bottom: 20px;">
    O usuário
    <a href="{{customerProfileUrl}}" style="font-weight: 700; text-decoration: none; color: #6c63ff;">{{customerName}}</a>
    <a href="{{customerProfileUrl}}" style="background: linear-gradient(135deg, #6c63ff, #a855f7); color: #fff; font-weight: 600; font-size: 0.75rem; border-radius: 6px; padding: 3px 8px;">@{{atSign}}</a>
    pediu para se afiliar à sua campanha
    <a href="{{campaignPageUrl}}" style="font-weight: 700; text-decoration: none; color: #6c63ff;">{{campaignName}}</a>
    <a href="{{campaignPageUrl}}" style="background: #f0f4ff; color: #6c63ff; border: 1px solid #c7d2fe; font-weight: 600; font-size: 0.75rem; border-radius: 6px; padding: 3px 8px;">#{{campaignKey}}</a>
    e solicitou <strong style="color: #1a202c;">{{commissionPercent}}%</strong> de comissão.
  </p>

  <div style="display: flex; gap: 12px; margin-bottom: 12px;">
    <div style="flex: 1; background: #f8faff; border: 1px solid #e0e7ff; border-radius: 10px; padding: 12px 16px;">
      <div style="font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: #a0aec0; margin-bottom: 4px;">Comissão solicitada</div>
      <div style="font-size: 1.5rem; font-weight: 800; color: #6c63ff;">{{commissionPercent}}<span style="font-size: 0.9rem;">%</span></div>
    </div>
    <div style="flex: 1; background: #f8faff; border: 1px solid #e0e7ff; border-radius: 10px; padding: 12px 16px;">
      <div style="font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: #a0aec0; margin-bottom: 4px;">Data da requisição</div>
      <div style="font-size: 0.95rem; font-weight: 700; color: #2d3748;">{{createdAt}}</div>
    </div>
  </div>

  <div style="display: flex; gap: 8px; background: #fffbeb; border: 1px solid #fde68a; border-left: 3px solid #f6ad55; border-radius: 8px; padding: 12px 16px; margin-bottom: 20px;">
    <span>💡</span>
    <span style="font-size: 0.85rem; color: #92400e; line-height: 1.65;">
      Esta comissão é enviada diretamente para a conta deste usuário a cada ticket vendido por indicação do mesmo.
    </span>
  </div>

  <a href="{{campaignAffiliatePageUrl}}" style="display: block; width: 100%; background: #f8faff; color: #6c63ff; border: 1px solid #c7d2fe; border-radius: 8px; font-weight: 600; font-size: 0.88rem; padding: 10px 0; cursor: pointer; text-align: center; text-decoration: none;">
    Administrar Afiliados
  </a>

</div>
`;

// Buttons
{
  /* <div style="font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: #a0aec0; margin-bottom: 10px;">
  O que você deseja fazer?
</div>

<div style="display: flex; gap: 8px; margin-bottom: 8px;">
  <button style="flex: 1; background: linear-gradient(135deg, #38a169, #48bb78); color: #fff; border: none; border-radius: 8px; font-weight: 700; font-size: 0.88rem; padding: 10px 0; cursor: pointer;">
    Aceitar
  </button>
  <button style="flex: 1; background: linear-gradient(135deg, #e53e3e, #fc8181); color: #fff; border: none; border-radius: 8px; font-weight: 700; font-size: 0.88rem; padding: 10px 0; cursor: pointer;">
    Recusar
  </button>
</div> */
}
